<template>
  <div class="list-page">
    <t-breadcrumb style="margin-bottom: 20px">
      <t-breadcrumb-item>应用列表</t-breadcrumb-item>
    </t-breadcrumb>
    <div class="list-warp">
      <t-button theme="primary" size="medium" class="add-btn" @click="handleAddApp">新建应用</t-button>
      <t-table
        class="list"
        :data="list"
        :columns="columns"
        rowKey="id"
        :loading="isLoading"
        :pagination="pagination"
        :sort="sort"
        @change="handleAppListChange"
      >
        <template #oper="slotProps">
          <t-button theme="primary" variant="text" @click="handleOpenApp(slotProps)">进入应用</t-button>
          <t-button
            theme="primary"
            variant="text"
            v-show="slotProps.row.roleType === 'admin'"
            @click="handleManageAccessEnd(slotProps)"
          >
            管理接入端
          </t-button>
          <t-button
            theme="primary"
            variant="text"
            v-show="slotProps.row.roleType === 'admin'"
            @click="handleAppUserManage(slotProps)"
          >
            用户管理
          </t-button>
          <t-button
            theme="primary"
            variant="text"
            v-show="slotProps.row.roleType === 'admin'"
            @click="handleEditApp(slotProps)"
          >
            编辑
          </t-button>
        </template>
      </t-table>
    </div>
    <t-dialog
      :visible.sync="addAppDialogVisible"
      :header="addAppForm.id ? '编辑应用' : '新增应用'"
      destroyOnClose
      :footer="false"
      :onClose="handleCloseAddAppDialog"
      :closeOnOverlayClick="false"
      class="add-app-dialog"
    >
      <div slot="body">
        <t-form :data="addAppForm" :rules="addAppFormRules" ref="form">
          <t-form-item label="产品名称" name="productType">
            <t-select
              v-model="addAppForm.productType"
              :options="productTypes"
              :keys="{ label: 'desc', value: 'productType' }"
              :disabled="!!addAppForm.id"
            ></t-select>
          </t-form-item>
          <t-form-item label="应用名称" name="applicationName">
            <t-input v-model="addAppForm.applicationName" placeholder="请输入应用名称"></t-input>
          </t-form-item>
          <t-form-item style="padding: 4px 0 0 0; margin-bottom: 0">
            <t-button theme="default" variant="base" @click="handleCloseAddAppDialog" class="close-dialog-btn">
              取消
            </t-button>
            <t-button theme="primary" type="submit" @click="handleSubmitAppForm">确认</t-button>
          </t-form-item>
        </t-form>
      </div>
    </t-dialog>
    <t-dialog
      :visible.sync="accessEndDialogVisible"
      header="管理接入端"
      destroyOnClose
      :footer="false"
      :onClose="handleCloseAccessEndDialog"
      :closeOnOverlayClick="false"
      class="access-end-dialog"
    >
      <div slot="body">
        <div class="access-end-title">
          <t-button theme="default" variant="base" @click="handleAddAccessEnd" style="width: 84px">新增接入端</t-button>
          <t-divider layout="vertical" style="height: 32px"></t-divider>
          <p>
            已接入过数据至DataNexus平台，请使用邮件授权
            <a href="https://docs.qq.com/doc/DSGJQV3NoclJLSnlB" target="_blank" style="text-decoration: none">
              下载模版及使用指引
            </a>
          </p>
        </div>
        <t-table
          class="access-end-list"
          :data="accessEndList"
          :columns="accessEndListColumns"
          rowKey="dataCollectionId"
          :loading="accessEndListIsLoading"
          :filterValue="accessEndListFilterValue"
          :selected-row-keys="selectAccessEndIdArr"
          @select-change="handleAccessEndSelectChange"
          @change="handleAccessEndListChange"
          :height="336"
        >
          <template #oper="slotProps">
            <t-button theme="primary" variant="text" style="padding: 0; width: 50px" @click="handleToSrdata(slotProps)">
              数据管理
            </t-button>
          </template>
          <template slot="empty">
            <div class="access-end-empty">
              <img :src="emptyImg" class="empty-img" />
              <p class="empty-txt">你尚未创建任何接入，请先新增接入端</p>
            </div>
          </template>
        </t-table>
        <div class="access-end-btns">
          <t-button theme="default" variant="base" @click="handleCloseAccessEndDialog">取消</t-button>
          <t-button theme="primary" type="submit" @click="handleSubmitAccessEnd">确认</t-button>
        </div>
      </div>
    </t-dialog>
  </div>
</template>

<script>
import { AppIcon, OrderDescendingIcon } from 'tdesign-icons-vue';
import lodash from 'lodash';
import dayjs from 'dayjs';
import emptyImg from '@/assets/images/404.png';
import {
  getProductTypeList,
  getApplicationList,
  createApplication,
  updateApplication,
  bindDataCollection,
  getDataCollection,
} from '@/api/application/list';

const defaultAppForm = {
  productType: '',
  applicationName: '',
};

export default {
  name: 'List',
  components: {
    AppIcon,
    OrderDescendingIcon,
  },
  data() {
    return {
      emptyImg,

      productTypes: [],

      sort: {},
      list: [],
      isLoading: false,
      columns: [
        {
          colKey: 'applicationName',
          title: '应用名称',
          minWidth: 150,
        },
        {
          colKey: 'productType',
          title: '产品名称',
          cell: (h, { col, row }) => this.productTypes.find(item => item.productType === row[col.colKey]).desc,
          minWidth: 120,
        },
        {
          colKey: 'dataCollectionList',
          title: '关联的接入端',
          cell: (h, { col, row }) =>
            row[col.colKey] && row[col.colKey].length > 0 ? (
              row[col.colKey].length
            ) : (
              <span style="color:#BBBBBB">0</span>
            ),
          minWidth: 150,
        },
        {
          colKey: 'createTime',
          title: '创建时间',
          sortType: 'all',
          sorter: true,
          cell: (h, { col, row }) => dayjs(row[col.colKey]).format('YYYY-MM-DD HH:mm:ss'),
          minWidth: 150,
        },
        {
          colKey: 'oper',
          title: '操作',
          minWidth: 300,
        },
      ],
      pagination: {
        pageSizeOptions: [],
        current: 1,
        pageSize: 10,
        total: 0,
      },

      addAppDialogVisible: false,
      accessEndDialogVisible: false,

      addAppForm: defaultAppForm,
      addAppFormRules: {
        productType: [{ required: true, message: '请选择产品名称', type: 'error', trigger: 'change' }],
        applicationName: [{ required: true, message: '请输入应用名称', type: 'error', trigger: 'blur' }],
      },

      selectApplicaitonId: null,
      selectAccessEndIdArr: [],
      tempAccessEndList: [],
      accessEndList: [],
      accessEndListColumns: [
        {
          colKey: 'row-select',
          type: 'multiple',
          width: 40,
          checkProps: ({ row }) => {
            return { disabled: row.status !== 'completed' };
          },
        },
        {
          colKey: 'dataCollectionId',
          title: '接入端ID',
          width: '99',
        },
        {
          colKey: 'name',
          title: '接入端名称',
          width: '160px',
        },
        {
          colKey: 'collectionType',
          title: '接入端类型',
          width: '110px',
        },
        {
          colKey: 'status',
          title: '状态',
          filter: {
            type: 'multiple',
            list: [{ label: 'completed', value: '已完成接入' }],
          },
          cell: (h, { col, row }) => (row[col.colKey] === 'completed' ? '已完成接入' : '接入中'),
          width: '117px',
        },
        {
          colKey: 'oper',
          title: '操作',
        },
      ],
      accessEndListIsLoading: false,
      accessEndListFilterValue: {},
    };
  },
  created() {
    this.init()
      .then(() => {
        this.getAppListData();
      })
      .catch(err => {
        this.$message.error(err && err.message ? err.message : '查询失败，请重试');
      });
  },
  methods: {
    async init() {
      const productTypes = await getProductTypeList();
      this.productTypes = productTypes;
    },
    handleAddApp() {
      // this.addAppForm = lodash.cloneDeep(defaultAppForm);
      // this.addAppDialogVisible = true;
      this.$message.info('请联系工作人员进行对接');
    },
    handleEditApp({ row }) {
      this.addAppForm = lodash.cloneDeep(row);
      this.addAppDialogVisible = true;
    },
    handleManageAccessEnd({ row }) {
      getDataCollection({ params: { id: row.id } })
        .then(accessEndList => {
          this.accessEndDialogVisible = true;
          this.selectAccessEndIdArr = row.dataCollectionList || [];
          this.selectApplicaitonId = row.id;
          this.accessEndList = accessEndList;
          this.tempAccessEndList = lodash.cloneDeep(accessEndList);
        })
        .catch(err => {
          this.$message.error(err && err.message ? err.message : '无法获取该应用可选的接入端');
        });
    },
    handleAppUserManage({ row }) {
      this.$router.push({
        name: 'ApplicationUserManage',
        params: {
          analysisAppId: row.id,
        },
      });
    },
    handleOpenApp({ row }) {
      this.$router.push({
        name: 'OverviewHome',
        query: {
          analysisAppId: row.id,
        },
      });
    },
    handleCloseAddAppDialog() {
      this.addAppDialogVisible = false;
      this.addAppForm = lodash.cloneDeep(defaultAppForm);
    },
    async handleSubmitAppForm() {
      const validResult = await this.$refs.form.validate();
      console.log(validResult);
      if (validResult !== true) {
        return;
      }
      const { id, productType, applicationName } = this.addAppForm;
      const method = id ? updateApplication : createApplication;
      method({ data: { id, productType, applicationName } })
        .then(result => {
          if (result) {
            this.$message.success('保存成功');
            this.handleCloseAddAppDialog();
            this.pagination.current = 1;
            this.getAppListData();
            return;
          }
          this.$message.error('保存失败，请重试');
        })
        .catch(err => {
          this.$message.error(err && err.message ? err.message : '保存失败，请重试');
        });
    },
    handleCloseAccessEndDialog() {
      this.selectApplicaitonId = null;
      this.selectAccessEndIdArr = [];
      this.tempAccessEndList = [];
      this.accessEndList = [];
      this.accessEndDialogVisible = false;
    },
    handleAddAccessEnd() {
      window.open('https://docs.qq.com/form/fill/DUnRwTnlDSGNoc2Vi?_w_tencentdocx_form=1#/fill');
    },
    handleToSrdata() {
      const confirmDia = this.$dialog.confirm({
        header: '跳转提示',
        body: '即将前往DataNexus平台进行数据管理',
        confirmBtn: '我知道了',
        cancelBtn: null,
        onConfirm: ({ e }) => {
          window.open('https://data.tencent.com');
          confirmDia.destroy();
        },
        onClose: ({ e, trigger }) => {
          confirmDia.hide();
        },
      });
    },
    handleSubmitAccessEnd() {
      bindDataCollection({ data: { id: this.selectApplicaitonId, dataCollectionList: this.selectAccessEndIdArr } })
        .then(result => {
          if (result) {
            this.getAppListData();
            this.$message.success('保存成功');
            this.handleCloseAccessEndDialog();
            return;
          }
          this.$message.error('保存失败，请重试');
        })
        .catch(err => {
          this.$message.error(err && err.message ? err.message : '保存失败，请重试');
        });
    },
    async getAppListData() {
      try {
        this.isLoading = true;
        const { current, pageSize } = this.pagination;
        const { sortBy, descending } = this.sort;

        const result = await getApplicationList({
          params: {
            pageNo: current,
            pageSize,
            ...(sortBy ? { orderByKey: 'create_time', isAsc: !descending } : {}),
          },
        });

        this.list = result.list;
        this.pagination = {
          ...this.pagination,
          total: result.total,
        };
      } catch (err) {
        this.list = [];
        this.$message.error(err && err.message ? err.message : '查询失败，请重试');
      }
      this.isLoading = false;
    },
    async handleAppListChange(changeParams, triggerAndData) {
      if (triggerAndData.trigger === 'sorter') {
        this.sort = changeParams.sorter || {};
      }
      if (triggerAndData.trigger === 'pagination') {
        this.pagination = changeParams.pagination;
      }
      await this.getAppListData();
    },
    handleAccessEndSelectChange(value, { selectedRowData }) {
      this.selectAccessEndIdArr = value;
    },
    handleAccessEndListChange(changeParams, triggerAndData) {
      if (triggerAndData.trigger === 'filter') {
        this.accessEndListFilterValue = changeParams.filter;
        if (changeParams.filter && changeParams.filter.status) {
          this.accessEndList = this.tempAccessEndList.filter(item => changeParams.filter.status.includes(item.status));
        }
      }
    },
  },
};
</script>
<style scoped lang="less">
.list-page {
  width: 100%;
  //height: 100%;
  padding-bottom: 20px;
  box-sizing: border-box;

  .list-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    color: #333333;
    margin: 0 0 20px 0;
  }

  .list-warp {
    width: 100%;
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 20px;
    border-radius: 4px;

    .add-btn {
      width: 80px;
      margin: 20px 0;
      font-size: 12px;
    }
    .list {
      width: 100%;

      ::v-deep .t-table {
        color: #333;
        font-size: 12px;

        thead {
          background-color: #f5f5f5;
          td {
            font-weight: 500;
          }
        }

        td {
          color: #333;
          padding: 11px 24px 10px 24px;
        }

        .t-table__cell--filter {
          margin-left: 11px;
        }

        .t-table__cell--sortable .t-table__cell--title > div:first-child {
          flex: 0 0 auto;
        }
        .t-pagination__total {
          font-size: 12px;
        }

        .t-pagination__number {
          font-size: 12px;
          //background-color: #5a66ff;
        }
      }
    }
  }

  ::v-deep .t-button--variant-base.t-button--theme-primary {
    font-size: 12px;
  }

  ::v-deep .t-button--variant-text.t-button--theme-primary {
    font-size: 12px;
  }

  .access-end-dialog {
    ::v-deep .t-dialog {
      width: 680px;
      height: 568px;

      .t-dialog__body {
        padding-top: 20px !important;
        box-sizing: border-box;
        max-height: 502px;
      }
    }
    .access-end-title {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      p {
        font-size: 12px;
        margin: 0;
      }

      a {
        color: #5a66ff;
        margin-left: 12px;
        cursor: pointer;
      }
    }

    .access-end-list {
      height: 378px;

      ::v-deep .t-table {
        box-sizing: border-box;
        border: 1px solid #e5e5e5;
        border-radius: 4px;
        overflow: hidden;

        td {
          padding: 0 24px;
          box-sizing: border-box;
          height: 41px;
          line-height: 41px;
          overflow: hidden;
          font-size: 12px;

          &.t-table__cell--selectable {
            text-align: center;
            padding: 0 12px;
          }
        }

        thead td {
          font-weight: 500;
          color: #333;
        }

        .t-table__cell--filter {
          margin-left: 11px;
        }

        .t-table--empty {
          height: auto;
        }
      }

      .access-end-empty {
        width: 100%;
        box-sizing: border-box;
        padding: 57px 0 85px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        .empty-img {
          width: 160px;
          height: 160px;
          margin-bottom: 12px;
        }
        .empty-txt {
          font-size: 14px;
          color: #333333;
          margin: 0;
        }
      }
    }

    .access-end-btns {
      margin-top: 20px;
      text-align: center;
    }
  }

  ::v-deep .t-dialog.t-dialog--default {
    padding: 20px;

    .t-dialog__header {
      line-height: 24px;
    }

    .t-dialog__body {
      padding: 12px 0 0 0;

      .t-form {
        .t-form__item {
          margin-bottom: 20px;
        }

        .t-form__label {
          color: #888;
          font-size: 12px;
        }

        .t-select {
          font-size: 12px;
        }

        .t-input__inner {
          font-size: 12px;
        }

        .t-input__extra {
          margin: 0;
          font-size: 12px;
          height: 22px;
          line-height: 22px;
        }
      }
    }

    .t-button--variant-base,
    .t-button--theme-primary {
      width: 80px;

      &.t-button--theme-default {
        box-sizing: border-box;
        border: 1px solid #ddd;
        background: #fff;
      }

      &.close-dialog-btn {
        margin: 0 4px 0 34px;
      }

      .t-button__text {
        font-size: 12px;
      }
    }
  }
}
</style>
